import React, { Component } from 'react';

import { withRouter } from 'react-router';
class FooterBar extends Component {
    state = {
        year: 2023
    };
    componentDidMount() {
        let year = new Date().getFullYear();
        this.setState({ year: year });
    }
    render() {
        return (
            <div style={{ textAlign: 'center' }}>
                {this.props.location.pathname === '/about' && (
                    <a href="https://inst.santec.com" target="_blank" rel="noopener noreferrer">
                        © {this.state.year} Santec Canada Corporation. All Rights Reserved.
                    </a>
                )}
            </div>
        );
    }
}
export default withRouter(FooterBar);
